<template>
  <div>

    <div class="container-fluid ps-md-0">    
  <div class="row g-0">

    <div class="d-none d-md-flex col-md-4 col-lg-6">

       <div id="slider">
    <ul id="slideWrap"> 
      <li><img src="../../assets/Group3176.png" alt=""></li>
      <li><img src="../../assets/Group3177.png" alt=""></li>
      <li><img src="../../assets/Group3178.png" alt=""></li>
      <li><img src="../../assets/Group3179.png" alt=""></li>
      <li><img src="../../assets/Group3180.png" alt=""></li>
      <li><img src="../../assets/Group3182.png" alt=""></li>
      <li><img src="../../assets/Group3183.png" alt=""></li>
      <li><img src="../../assets/Group3184.png" alt=""></li>
            <li><img src="../../assets/Group3185.png" alt=""></li>
      <li><img src="../../assets/Group3186.png" alt=""></li>
      <li><img src="../../assets/Group3187.png" alt=""></li>
            <li><img src="../../assets/Group3188.png" alt=""></li>
            <li><img src="../../assets/Group3189.png" alt=""></li>
            <li><img src="../../assets/Group3190.png" alt=""></li>
            <li><img src="../../assets/Group3191.png" alt=""></li>



    </ul>
    <a id="prev" href="#">&#8810;</a>
    <a id="next" href="#">&#8811;</a>
  </div>

    </div>
    <div class="col-md-8 col-lg-6">
      <div class="login d-flex align-items-center py-5">
        <div class="container">
          <div class="row">
            <div class="col-md-9 col-lg-8 mx-auto">
              <h2 class="login-heading mb-2">Sign In</h2>
 <div class="mb-2">New here?
              <a
                href="/#/register"
                id="login_signup"
                style="font-weight: 600; color: cornflowerblue"
              >
                Create account
              </a>
            </div>
              <!-- Sign In Form -->
              <form class="form" v-on:submit.prevent="sendOTP">
                <div class="mb-2">
  <VuePhoneNumberInput
              class="form-control h-auto "
              v-model="number"
              @update="results = $event"
              default-country-code="IN"
              :preferred-countries="['KR', 'GB', 'AE']"
              style="border-color:1px solid white"
               autocomplete="off"
              :class="{ 'is-invalid': submitted && $v.number.$error }" 
            />     
           <div v-if="submitted && !$v.number.required" class="invalid-feedback">Phone Number is required</div>
         
                </div>
                 <div id="recaptcha-container"></div>
                  <div class="d-grid">
                  <button  v-if="!window.confirmationResult || !otpsend" class="btn btn-lg btn-danger btn-login text-uppercase fw-bold mb-2" 
                 style="border-radius:3rem">Send OTP</button>
                </div>
              </form>
              <form v-if="window.confirmationResult || otpsend"  v-on:submit.prevent="sendOTPOtp">
                 <p class="info">
                  We have sent you a verification code to the phone number that
                  you have entered.</p>
                <div class="form-floating mb-3">
                  <input type="text" v-model="otp" class="form-control" id="floatingPassword" placeholder="Verification Code" maxlength="6" autocomplete="off"
                  :class="{ 'is-invalid': submittedotp && $v.otp.$error }">
                  <label for="floatingPassword">Verification code</label>
                             <div v-if="submittedotp && !$v.otp.required" class="invalid-feedback">Verification code is required</div>

                </div>


                <div class="d-grid">
                  <button class="btn btn-lg btn-danger btn-login text-uppercase fw-bold mb-2" type="submit" style="border-radius:3rem">Sign in</button>
                  <div class="text-center">
                    <a class="small"  style="
                      font-weight: 600;
                      color: cornflowerblue;cursor:pointer
                    " @click="reSendPhoneCode">Resend Code?</a>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    <!-- <CRow>
      <CCol sm="6" md="0" lg="6">
        <vue-displacement-slideshow />
      </CCol>
      <CCol lg="4" class="signin">
        <CForm class="form">
          <div class="pt-lg-0 pt-5">
            <h3 style="font-size: 21px; font-weight: bold">Sign in</h3>
            <span style="font-size: 18px"
              >New here?
              <a
                href="/#/register"
                id="login_signup"
                style="font-weight: 600; color: cornflowerblue"
              >
                Create account
              </a>
            </span>
          </div>

          <div class="form-group">
            <p class="phone">Your phone number</p>
            <VuePhoneNumberInput
              class="form-control h-auto font-size-25"
              v-model="number"
              size="lg"
              @update="results = $event"
              default-country-code="IN"
              :preferred-countries="['KR', 'GB', 'AE']"
            />
          </div>
          <div id="recaptcha-container"></div>
          <div>
            <CCol col="6" sm="4" md="4" xl class="mb-3 mb-xl-0">
              <b-button
                class="button"
                variant="danger"
                @click="sendOtp"
                :disabled="formHaserror"
              >
                Login <b-spinner v-if="isLoading" small type="grow"></b-spinner>
              </b-button>
            </CCol>
          </div>
          <div v-if="window.confirmationResult || otpsend">
            <CForm>
              <div class="form-group">
                <p class="info">
                  We have sent you a verification code to the phone number that
                  you have entered.
                </p>
                <div style="font-size: 17px; font-weight: 500">
                  <label>Verification Code</label>
                  <a
                    style="
                      float: right;
                      font-weight: 600;
                      color: cornflowerblue;
                    "
                    @click="reSendPhoneCode"
                    >Resend Code</a
                  >
                </div>

                <CInput
                  class="input-white"
                  type="text"
                  size="lg"
                  autocomplete="one-time-code"
                  v-model="otp"
                >
                </CInput>
              </div>
              <div class="py-0 pb-6">
                <CCol col="6" sm="4" md="6" xl class="mb-3 mb-xl-0">
                  <b-button class="button1" variant="danger" @click="verifyOtp">
                    Submit
                    <b-spinner v-if="isVLoading" small type="grow"></b-spinner>
                  </b-button>
                </CCol>
              </div>
            </CForm>
          </div>
        </CForm>
      </CCol>
    </CRow> -->
  </div>
</template>

<script>

import Vue from "vue";

import firebase from "firebase";
import utils from "@/services/utils.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);
import "sweetalert2/dist/sweetalert2.min.css";
import TheLoader from "../components/TheLoader.vue";
    import { required, email, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  name: "Login",
  components: {
    VuePhoneNumberInput,TheLoader
  },
  props:{
  },
  data() {
    return {
      submitted:false,
      submittedotp:false,
      image:"https://firebasestorage.googleapis.com/v0/b/nuchat-85ad0.appspot.com/o/bcd30560-48fb-11ec-adc4-6d5bdaa6cbe4?alt=media&token=5e7d6ee3-340d-4ed3-acda-4b2718a4890a",
      phNo: "",
      countrycode:"",
      appVerifier: "",
      otp: "",
      successmsg: false,
      otpsend: false,
      number: "",
      results: null,
      window: {},
      isLoading: false,
      formHaserror: false,
    };
  },
          validations: {
                number: { required },
                otp:{required}
          },
          computed:{},
  mounted: function () {
   var responsiveSlider = function() {

var slider = document.getElementById("slider");
var sliderWidth = slider.offsetWidth;
var slideList = document.getElementById("slideWrap");
var count = 1;
var items = slideList.querySelectorAll("li").length;
var prev = document.getElementById("prev");
var next = document.getElementById("next");

window.addEventListener('resize', function() {
  sliderWidth = slider.offsetWidth;
});

var prevSlide = function() {
  if(count > 1) {
    count = count - 2;
    slideList.style.left = "-" + count * sliderWidth + "px";
    count++;
  }
  else if(count = 1) {
    count = items - 1;
    slideList.style.left = "-" + count * sliderWidth + "px";
    count++;
  }
};

var nextSlide = function() {
  if(count < items) {
    slideList.style.left = "-" + count * sliderWidth + "px";
    count++;
  }
  else if(count = items) {
    slideList.style.left = "0px";
    count = 1;
  }
};

next.addEventListener("click", function() {
  nextSlide();
});

prev.addEventListener("click", function() {
  prevSlide();
});

setInterval(function() {
  nextSlide()
}, 3000);

};

window.onload = function() {
responsiveSlider();  
}


  },
  methods: {
    sendOTP() {
      this.submitted =true;
      let self = this;
                      self.$v.number.$touch();
                if (self.$v.number.$invalid) {
                        this.formHaserror = false;
                    return;
                }
            let phoneNumber = this.phNo;
      let appVerifier = this.appVerifier;

      const db = firebase.firestore();
      db.collection("users")
        .where("phone", "==", this.phNo)
        .get()
        .then((snapshot) => {
          if (snapshot.docs.length != 0) {
            snapshot.forEach((doc1) => {
              if (doc1.data().type == "Consumer") {
                self.isLoading = false;
                this.name = doc1.data().nickname;
                this.$swal({
                  title:
                    "Welcome! " +
                    this.name +
                    ", Please register to Create a store",
                  text:'Thanks for choosing us.',
                  type: "warning",
                  imageUrl:"https://firebasestorage.googleapis.com/v0/b/nuchat-85ad0.appspot.com/o/340998e0-48fe-11ec-bd88-4969465e3ec0?alt=media&token=73411030-b963-47a1-9abd-be8dc4c853f1",
                  imageWidth:200,
                  imageHeight:100,
                  showCancelButton: true,
                  confirmButtonColor: "#4026e3",
                  confirmButtonText: "Click here to Register!",
                }).then((result) => {
                  console.log(result);

                  if (result.value == true) {
                    self.$router.push({ name: "Register" });
                  } else if (result.isDismissed == true) {
                    self.number = "";
                    self.formHaserror = false;
                  }
                });
              } else {
                firebase
                  .auth()
                  .signInWithPhoneNumber(phoneNumber, appVerifier)
                  .then(function (confirmationResult) {

                    self.window.confirmationResult = confirmationResult;
                    console.log(self.window.confirmationResult);
                    self.otpsend = true;
                    self.isLoading = false;
                    Vue.$toast.success("Verification Code send successfully!", {
                      position: "top-right",
                    });
                  })
                  .catch(function (error) {
                    self.isLoading = false;
                    self.formHaserror = false;
                    console.log("Error in sending SMS", error);
                    Vue.$toast.error(error, {
                      position: "top-right",
                    });
                  });
              }
            });
          } else {
                            self.isLoading = false;
                                self.formHaserror = false;
            Vue.$toast.error("This Phone Number  doesn't exist", {
              position: "top-right",
            });
          }
        });
    
    },
    reSendPhoneCode() {
      this.sendOTP();
    },
    sendOTPOtp:function(e) {
      this.submittedotp=true;
      this.$v.otp.$touch();
                if (this.$v.otp.$invalid) {
                    return;
                }
        let code = this.otp;
        this.successmsg = true;
        this.window.confirmationResult
          .confirm(code)
          .then((result) => {
            //console.log(user.providerData,"loginuserrr")
            //console.log(result.data(),".data()")
            utils.saveToken(result.user.xa, JSON.stringify(result));
            console.log("result", result);
            this.getUserData();
            this.isVLoading = false;
            Vue.$toast.success("User loggedIn Successfully.", {
              position: "top-right",
            });

            // this.router.push('/dashboard')
          })
          .catch(function (error) {
            console.log("Error in Logging", error);
            Vue.$toast.error("Invalid verification code.", {
              position: "top-right",
            });
          });
    },
    getUserData() {
      const db = firebase.firestore();
      let self = this;
      db.collection("users")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let symbol = doc.data().symbol;
            let proimg = doc.data().photoUrl;
            localStorage.setItem("proimg", proimg);
            localStorage.setItem("symbol", symbol);
            console.log("User symbol", symbol);
            console.log("proimg", proimg);
            self.$router.push({ name: "Catalog" });
          });
        });
    },
    initReCaptcha() {
      setTimeout(() => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          "recaptcha-container",
          {
            size: "invisible",
            callback: function () {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // ...
            },
            "expired-callback": function () {
              // Response expired. Ask user to solve reCAPTCHA again.
              // ...
            },
          }
        );
        //
        this.appVerifier = window.recaptchaVerifier;
      }, 1000);
    },
    // submit() {
    //   firebase
    //   .auth()
    //   .signInWithEmailAndPassword(this.form.email, this.form.password)
    //     .then(data  => {
    //       let self = this;
    //       utils.saveToken(data.xa, JSON.stringify(data))
    //       self.$router.push({ name: "Dashboard" })
    //     })
    //     .catch(err => {
    //       this.error = err.message;
    //     });
    // }
  },
  watch: {
    results() {
      console.log(this.results)
      this.phNo = this.results["formattedNumber"];
      this.countrycode=this.results["countryCode"];
      localStorage.setItem("CC",this.countrycode)
    },
  },
  created() {
    this.initReCaptcha();
  },
};
</script>
<style>
/* img{
  width:100%;
  height:170%
} */

/* .phone {
  font-size: 17px;
  font-weight: bold;
}
.signin {
  padding-top: 100px;
}
.info {
  color: #868aa8;
  font-size: 16px;
  margin-bottom: 0.5rem;
}
a {
  cursor: pointer;
}
.button {
  border-radius: 30px !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  font-size: 17px !important;
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
  margin-top: 0.25rem !important;
  margin-bottom: 0.25 !important;
  margin-right: 0.25rem !important;
}
.button1 {
  border-radius: 30px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 17px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-top: 3rem;

  margin-bottom: 1.75;
  margin-right: 1.75rem;
}
.spinner {
  position: relative;
  top: -33px !important;
  left: 100px !important;
}
.spinner1 {
  position: relative;
  top: -37px !important;
  left: 100px !important;
}
canvas {
  width: 550px !important;
  height: 650px !important;
  max-height: 1060px !important;
} */
.login {
  min-height: 100vh;
  font-family: 'Assistant';
}



.login-heading {
  font-weight: 300;
}

.btn-login {
  font-size: 0.9rem;
  letter-spacing: 0.05rem;
  padding: 0.75rem 1rem;
}
#slider {
  position: relative;
  width: 100%;
  height: 100%;
 max-width:600px;
  overflow: hidden;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
}
#slider ul {
  position: relative;
  list-style: none;
  width: 10000%;
  padding: 0;
  margin: 0;
  transition: all 750ms ease;
  left: 0;
}
#slider ul li {
  position: relative;
  height: 10px !important;
 
  float: left;
}
#slider ul li img{
  width: 42rem;
  height: 42rem;
}
 
#slider #prev, #slider #next {
  width: 50px;
  line-height: 50px;
  border-radius: 50%;
  font-size: 2rem;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.6);
  text-align: center;
  color: white;
  text-decoration: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 150ms ease;
}
#slider #prev:hover, #slider #next:hover {
  background-color: rgba(0, 0, 0, 0.5);
  text-shadow: 0;
}
#slider #prev {
  left: 10px;
  display: none;
}
#slider #next {
  right: 10px;
    display: none;

}
</style>
